export async function readSwerveSlotPythonSource(slotAssetId: string): Promise<string> {
  const readPromise = window.robotService?.readPythonAsset?.(slotAssetId);
  if (!readPromise) {
    throw new Error('readPythonAsset unavailable');
  }

  const pythonSource = await readPromise;
  if (typeof pythonSource !== 'string') {
    throw new Error('readPythonAsset returned no data');
  }

  return pythonSource;
}
